import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { useNotifications } from '../../context/NotificationContext';
import { useNewRequestsCount } from '../../hooks/useNewRequestsCount';
import ThemeToggle from '../common/ThemeToggle';

// Les icônes SVG restent inchangées...
const DashboardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
  </svg>
);

const SupportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
  </svg>
);

const RequestsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
  </svg>
);

const MonitoringIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
  </svg>
);

// Prospection : combiné téléphone + fiche (l'outil d'appel de l'étape 1)
const ProspectionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
  </svg>
);

const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
  </svg>
);

const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
  </svg>
);

// Liste des liens de navigation — refonte « Clients » (fusion Utilisateurs + Sites)
const navItems = [
  { name: 'Tableau de bord', path: '/dashboard', icon: <DashboardIcon /> },
  { name: 'Clients', path: '/clients', icon: <UsersIcon /> },
  { name: 'Demandes', path: '/creation-requests', icon: <RequestsIcon /> },
  { name: 'Support', path: '/support', icon: <SupportIcon /> },
  // Prospection : import Apify, file d'appel, fiche et tunnel (étape 1)
  { name: 'Prospection', path: '/prospection', icon: <ProspectionIcon /> },
  // Lot I5 : écran de surveillance en LECTURE SEULE (incidents serveur + emails en échec).
  { name: 'Monitoring', path: '/monitoring', icon: <MonitoringIcon /> },
];

const DashboardLayout = () => {
  const { currentUser, logout } = useAuthContext();
  const {
    newTicketsCount,
    resetNewTicketsCount,
    requestUnreadCount,
    ticketReplyUnreadCount
  } = useNotifications();
  const newRequestsCount = useNewRequestsCount();
  // Badges : nouveaux tickets + réponses client (support) ; demandes = messages clients
  // (prioritaires) sinon nouvelles demandes à prendre en charge.
  const supportUnreadCount = newTicketsCount + ticketReplyUnreadCount;
  const requestsBadgeCount = requestUnreadCount || newRequestsCount;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar pour mobile (overlay) */}
      <div 
        className={`fixed inset-0 bg-base-300 bg-opacity-50 z-20 lg:hidden transition-opacity duration-200 ${
          sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <div 
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-base-100 border-r border-base-200 transform transition-transform duration-200 lg:translate-x-0 lg:static lg:inset-0 flex flex-col ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex items-center justify-center h-16 border-b border-base-200">
          <span className="text-xl font-bold text-primary">MSD Admin</span>
        </div>

        <nav className="mt-5 flex-grow">
          <div className="px-2">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => 
                  `flex items-center px-4 py-3 mt-1 rounded-lg transition-colors ${
                    isActive 
                      ? 'bg-primary text-primary-content font-medium'
                      : 'text-base-content hover:bg-base-200'
                  }`
                }
                onClick={() => {
                  setSidebarOpen(false);
                  // Les réponses client restent pastillées jusqu'à l'ouverture du détail.
                  if (item.path === '/support' && newTicketsCount > 0) resetNewTicketsCount();
                }}
              >
                <span className="mr-3">{item.icon}</span>
                {item.name}
                {item.path === '/support' && supportUnreadCount > 0 && (
                  <span className="ml-auto bg-error text-error-content text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                    {supportUnreadCount > 99 ? '99+' : supportUnreadCount}
                  </span>
                )}
                {item.path === '/creation-requests' && requestsBadgeCount > 0 && (
                  <span className="ml-auto bg-error text-error-content text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                    {requestsBadgeCount > 99 ? '99+' : requestsBadgeCount}
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
        
        {/* Bouton de déconnexion en bas du sidebar */}
        <div className="px-2 pb-5 mt-auto border-t border-base-200 pt-3">
          <button
            onClick={handleLogout}
            className="flex items-center px-4 py-3 w-full rounded-lg transition-colors text-base-content hover:bg-base-200"
          >
            <span className="mr-3"><LogoutIcon /></span>
            Déconnexion
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="bg-base-100 shadow-sm z-10 border-b border-base-200">
          <div className="px-4 py-3 flex justify-between items-center">
            <button
              onClick={toggleSidebar}
              className="text-base-content focus:outline-none lg:hidden hover:text-primary transition-colors"
            >
              <MenuIcon />
            </button>
            
            <div className="flex items-center space-x-4">
              {/* Toggle de thème */}
              <ThemeToggle />
              
              {/* Affichage de l'email uniquement */}
              <div className="text-sm font-medium text-base-content hidden md:block">
                {currentUser?.email || 'Admin'}
              </div>
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto bg-base-200 p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;